import {
    Grid,
    Paper,
    IconButton } from "../../ui";
import {
  BillStatus,
  CART_INITIAL_STATE,
  CartDets,
  INITIATED,
  InternalBillType,
  TRIP_ASSIGNED,
  TRIP_RUNNING
} from "../../../constants/constant";
import SnpButton from "../../global/SnpButton";
import './BillListDisplay.css';

import DirectionsRunIcon from '../../ui/icons/DirectionsRun';
import LocalShippingIcon from '../../ui/icons/LocalShipping';

const BillListDisplay = ({
    cartType, data, deliveryStatus,
    quickBillAllowed, onClickQuickBill, onClickBill, paidItemColor, isOnlineBill, onClickDeliverItem
}) => {

    const paperBackgroundColor = (data) => {
        if (cartType === CartDets.Resto) {
            if (paidItemColor(data)) return "#a1b487";
            if (data.billStatus === BillStatus.PARTIALLYPAID) return "#f08888";
        } else if (cartType === CartDets.Watch) {
            if (deliveryStatus === INITIATED) return "#7ce3f0ff";
            if (deliveryStatus === TRIP_ASSIGNED) return "#ebb769ff";
            if (deliveryStatus === TRIP_RUNNING) return "#7eef82ff";
        }
        return "white";
    };

    const appendBillDetails = (data) => {
        let resp = "";
        if (data.billAddBy && data.billAddBy !== CART_INITIAL_STATE.userName) {
            resp = "@ " + data.billAddBy;
        }
        if (data.custName) {
            if (resp) {
                resp = resp + "\nCust:" + data.custName;
            } else {
                resp = "Cust:" + data.custName;
            }
        }
        if (data.tripDetails) {
            resp = resp + "\nTrip Status: " + data.tripDetails;
        }
        return resp;
    }

    return (
        <Grid item md={2} xs={6} sm={4} key={data.billNo} sx={{ padding: 0, mt: 2 }}>
            {quickBillAllowed &&
                data.billStatus < BillStatus.NOTPAID &&
                data.billType === InternalBillType.TakeAway && (
                    <SnpButton
                        variant="contained"
                        mbgcolor="#543d4e"
                        mheight="32px"
                        mwidth="143px"
                        mborderradius="14px"
                        style={{ float: "center" }}
                        onClick={() => onClickQuickBill(data)}
                    >
                        <DirectionsRunIcon /> Quick Bill
                    </SnpButton>
                )}

            <Paper
                elevation={0}
                onClick={() => onClickBill(data)}
                className="showbills-data-container"
                sx={{
                    position: "relative",
                    borderRadius: 4,
                    backgroundColor: paperBackgroundColor(data),
                    padding: "8px",
                }}
            >
                {
                    isOnlineBill &&
                    <IconButton
                        size="small"
                        sx={{
                            position: "absolute",
                            top: 4,
                            left: 4,
                            color: "white",
                            backgroundColor: "black",
                            "&:hover": {
                                opacity: 0.9,
                            },
                        }}

                        onClick={(e) => {
                            e.stopPropagation();
                            onClickDeliverItem(data);
                        }}
                    >
                        <LocalShippingIcon fontSize="small" />
                    </IconButton>
                }

                <div style={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <p style={{
                        fontSize: '10px', fontFamily: "sans-serif", textAlign: "right",
                        margin: 0,
                    }}>{data.delvName ? `${data.billNo}(${data.delvName})` : data.billNo}</p>
                    <p style={{ fontSize: '11px', fontWeight: 'bold', fontFamily: "sans-serif" }}>Order no.{data.token} (₹{data.finalPrice})</p>
                    {data.lapsedTime && <p style={{ fontSize: '10px', fontFamily: "sans-serif" }}>{data.lapsedTime}</p>}
                    <p style={{
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word', fontSize: '10px',
                        justifyContent: 'center', alignItems: 'center',
                        alignContent: 'center', fontFamily: "sans-serif"
                    }}>
                        {appendBillDetails(data)}
                    </p>
                </div>
            </Paper>
        </Grid>
    );
};

export default BillListDisplay;
